"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error,
    hasNext,
    hasPrev,
    nextPage,
    prevPage,
    currentPage,
    totalPages
  } = usePosts();
  if (loading) {
    return <div data-section-id="169254" className="mx-auto grid max-w-[1150px] grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 px-5">
        {[...Array(9)].map((_, i) => <Card key={i} data-index={i} className="flex flex-col overflow-hidden rounded-lg border-none shadow-md">
            <AspectRatio ratio={16 / 9} className="bg-muted/30 animate-pulse" />
            <CardHeader className="px-6 pt-6 pb-2">
              <div className="h-6 w-3/4 animate-pulse rounded bg-muted/50" />
            </CardHeader>
            <CardContent className="flex-grow px-6 py-2">
              <div className="space-y-2">
                <div className="h-4 w-full animate-pulse rounded bg-muted/50" />
                <div className="h-4 w-5/6 animate-pulse rounded bg-muted/50" />
              </div>
            </CardContent>
            <CardFooter className="px-6 pt-2 pb-6">
              <div className="h-[52px] w-full animate-pulse rounded-md bg-muted/50" />
            </CardFooter>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Failed to load latest insights. Please try again later.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>No property management articles found at the moment.</p>
      </div>;
  }
  return <div className="mx-auto max-w-[1150px] px-5">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, i) => <Card key={post.id} data-index={i} className="flex flex-col overflow-hidden rounded-xl border border-border/50 bg-card/80 backdrop-blur-sm shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
            <div className="relative">
              <AspectRatio ratio={16 / 9}>
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608256/img/generic_blog_placeholder.png"} alt={post.title} className="h-full w-full object-cover" />
              </AspectRatio>
              {post.categories && post.categories.length > 0 && <div className="absolute left-4 top-4">
                  <Badge className="bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90">
                    {post.categories[0].name}
                  </Badge>
                </div>}
            </div>
            
            <CardHeader className="px-6 pt-6 pb-2">
              <h3 className="line-clamp-2 text-xl font-bold font-default text-primary">
                {post.title}
              </h3>
            </CardHeader>
            
            <CardContent className="flex-grow px-6 py-2">
              <div className="line-clamp-3 text-base leading-relaxed text-muted-foreground font-sans" dangerouslySetInnerHTML={{
            __html: post.excerpt || ""
          }} />
            </CardContent>
            
            <CardFooter className="px-6 pt-2 pb-6">
              <Button asChild className="w-full rounded-md bg-gradient-to-r from-primary to-secondary py-6 text-base font-semibold text-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md">
                <Link to={post.link || "#"}>
                  Read More <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </CardFooter>
          </Card>)}
      </div>

      {totalPages > 1 && <div className="mt-12 flex items-center justify-center gap-4">
          <Button variant="outline" size="sm" onClick={() => prevPage()} disabled={!hasPrev} className="rounded-md border-primary/20 hover:bg-primary/5">
            Previous
          </Button>
          <div className="text-sm font-medium text-muted-foreground">
            Page {currentPage} of {totalPages}
          </div>
          <Button variant="outline" size="sm" onClick={() => nextPage()} disabled={!hasNext} className="rounded-md border-primary/20 hover:bg-primary/5">
            Next
          </Button>
        </div>}
    </div>;
}
export default function BlogGrid() {
  const wp_query_params = {
    per_page: 9
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="blogposts" className="bg-background text-foreground py-20">
      <div className="mx-auto mb-14 max-w-[1150px] px-5 text-center">
        <h2 className="mb-4 text-3xl font-bold font-default text-primary md:text-4xl">
          Property Management Insights
        </h2>
        <p className="mx-auto max-w-2xl text-lg leading-relaxed text-muted-foreground font-sans">Stay informed with expert advice on maximizing rental returns, Central Florida market trends, and professional property maintenance tips.<br />For more information contact us at 1-407-298-9777</p>
      </div>
      
      <PostsProvider wp_query={{
      per_page: 9
    }}>
        <BlogGridConsumer />
      </PostsProvider>
    </section>;
}